import fs from "fs";
import path from "path";
import os from "os";

export const getUniqueFileName = (filePath: string): string => {
  if (!fs.existsSync(filePath)) {
    return filePath;
  }

  const fileExt = path.extname(filePath);
  const baseName = path.basename(filePath, fileExt);
  let index = 1;
  let newFilePath;

  do {
    newFilePath = path.join(
      path.dirname(filePath),
      `${baseName} (${index})${fileExt}`,
    );
    index++;
  } while (fs.existsSync(newFilePath));

  return newFilePath;
};

export const readFileAsBlob = (filePath: string) => {
  return new Promise((resolve, reject) => {
    fs.readFile(filePath, (err, data) => {
      if (err) {
        reject(err);
      } else {
        const blob = new Blob([data]);
        resolve(blob);
      }
    });
  });
};

export const replaceInvalidCharacters = (fileName: string): string => {
  const invalidCharactersWindows = /[<>:"\/\\|?*\x00-\x1F]/g; // Invalid characters on Windows
  const invalidCharactersLinux = /\x00/g; // Invalid characters on Linux (only NULL character)

  // temp for test turned off checking
  const invalidCharactersRegex =
    os.platform() === "win32"
      ? invalidCharactersWindows
      : invalidCharactersLinux;
  return fileName.replace(invalidCharactersWindows, "");
};

export const changeFileType = (
  file: File,
  newMimeType: string,
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);

    reader.onload = () => {
      const arrayBuffer = reader.result as ArrayBuffer;
      const newBlob = new Blob([arrayBuffer], { type: newMimeType });
      const newFile = new File([newBlob], file.name, {
        type: newMimeType,
      });

      resolve(newFile);
    };

    reader.onerror = (error) => {
      reject(error);
    };
  });
};
